import getFormatTimeToHHMM from 'Domain/monitoring/helper/getFormatTimeToHHMM';
import { isEmpty } from 'lodash';

const getCurrentShiftResponse = (data) => {
  const selectedShift = data?.shift;

  if (isEmpty(selectedShift)) return { name: '', id: '', time: '' };

  const startShift = getFormatTimeToHHMM(selectedShift?.startTime);
  const endShift = getFormatTimeToHHMM(selectedShift?.endTime);

  return {
    name: selectedShift?.name ?? '',
    id: selectedShift?.id ?? '',
    time: startShift && endShift ? `${startShift} - ${endShift}` : '',
  };
};

export default getCurrentShiftResponse;
